import React from 'react';
import PropTypes from 'prop-types';
import styleVariables from './variables';

const RootContext = React.createContext({
  window: { width: window.innerWidth, height: window.innerHeight }
});

export const RootConsumer = RootContext.Consumer;

const RootComponent = class Root extends React.Component {

  static propTypes = {
    children: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillMount() {
    this.updateWindowDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({
      window: { width: window.innerWidth, height: window.innerHeight },
      isMobile: window.innerWidth < styleVariables.tabletBreakpoint,
      isComputer: window.innerWidth >= styleVariables.tabletBreakpoint,
      isLargeScreen: window.innerWidth >= styleVariables.largeScreenBreakpoint
    });
  }

  render() {
    return (
      <RootContext.Provider value={this.state}>
        {this.props.children}
      </RootContext.Provider>
    );
  }
};

export default RootComponent;



// WEBPACK FOOTER //
// ./webpack/components/RootComponent.js